export default "__VITE_ASSET__NAbvV920__"